import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { AppStyles } from '../styles/AppTheme';
import draftToHtml from 'draftjs-to-html';
import parse from 'html-react-parser';

export class RenderHtmlTextHelper {
  static renderHtmlText(attribute) {
    this.defaultContent = JSON.parse(attribute)
    if (this.defaultContent.__azformatted) {
      return draftToHtml(this.defaultContent.__azformatted)
    } else {
      return ''
    }
  }
}


// WEBPACK FOOTER //
// ./src/helpers/RenderHtmlTextHelper.js